import styled from 'styled-components';
import colors from 'Styles/colors';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
`;
Wrapper.displayName = 'Wrapper';

export const RangeWrapper = styled.div`
  width: ${({ width }) => width || '100%'};
  margin: 6px auto 10px auto;
  position: relative;
  height: 56px;
  ${({ isDisabled }) => isDisabled && `
    opacity: 0.8;
    cursor: not-allowed;
  `}
`;
RangeWrapper.displayName = 'RangeWrapper';

export const Title = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 2.08;
  user-select: none;
  text-align: start;
  color: ${({ theme }) => theme.text.runAgentInputLabel};
`;
Title.displayName = 'Title';

export const CustomRail = styled.div`
  position: absolute;
  top: 16px;
  left: 0;
  width: 99%;
  height: 5px;
  overflow: hidden;
  z-index: 0;
  display: flex;
  margin-left: 2px;
`;
CustomRail.displayName = 'CustomRail';

export const Segment = styled.div`
  height: 100%;
  width: ${({ width }) => width};
  background-color: ${({ color }) => color};
  transition: background 0.2s;
  opacity: ${({ isOutsideRange }) => isOutsideRange ? '0.5' : '1'};
`;
Segment.displayName = 'Segment';

export const Thumb = styled.div`
  border: 1px solid #006dc7;
  background: ${colors.blueCerulean};
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 8px;
  left: ${({ leftPos }) => leftPos};
  transform: ${({ translateX }) => `translateX(${translateX})`};
  z-index: 2;
  & > svg {
    ${({ isDisabled }) => isDisabled && `
      cursor: not-allowed;
  `}
  }
`;
Thumb.displayName = 'Thumb';

export const SliderContainer = styled.div`
  position: relative;
  z-index: 1;
  .rc-slider-disabled {
    background-color: transparent;
  }
`;
SliderContainer.displayName = 'SliderContainer';

export const Label = styled.span`
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  color: #8da6be;
  font-weight: 600;
  font-size: 12px;
  white-space: nowrap;
  font-family: CentraNo2;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 2.1;
  letter-spacing: normal;
  color: #8da6be;
  pointer-events: none;
  cursor: default;

  ${({ firstLabel }) => firstLabel && `
    left: 0;
    transform: none;
    text-align: left;
  `};

  ${({ lastLabel }) => lastLabel && `
    left: 100%;
    transform: translateX(-100%);
    text-align: right;
  `};
`;
Label.displayName = 'Label';
